import { useState, useEffect } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { fetchHiddenLessons, setLessonHidden } from '../../services/api';
import { BUILT_IN_LESSONS } from '../../data/builtInLessons';
import Loading from '../Loading';

// Admin záložka: seznam vestavěných lekcí s přepínačem Zobrazit/Schovat.
// Schovaná lekce zmizí běžným uživatelům z menu (data o pokroku zůstávají).
const LessonVisibilityManager = () => {
  const [hiddenTopics, setHiddenTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingTopic, setSavingTopic] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const data = await fetchHiddenLessons();
        setHiddenTopics(data.hidden_topics || []);
      } catch (err) {
        console.error('Error fetching hidden lessons:', err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const toggle = async (topic, currentlyHidden) => {
    const nextHidden = !currentlyHidden;
    setSavingTopic(topic);
    try {
      await setLessonHidden(topic, nextHidden);
      setHiddenTopics((prev) =>
        nextHidden ? [...prev, topic] : prev.filter((t) => t !== topic)
      );
    } catch (err) {
      console.error('Error updating lesson visibility:', err);
      alert(err.message || 'Změna se nepodařila.');
    } finally {
      setSavingTopic(null);
    }
  };

  if (loading) return <Loading />;

  return (
    <div>
      <p style={{ color: '#6b7280', fontSize: '14px', marginBottom: '20px' }}>
        Schované lekce se běžným uživatelům nezobrazí v menu. Vy je zde vidíte
        dál a můžete je kdykoli zobrazit zpět. Pokrok uživatelů se nemaže.
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {BUILT_IN_LESSONS.map((lesson) => {
          const hidden = hiddenTopics.includes(lesson.topic);
          const saving = savingTopic === lesson.topic;
          return (
            <div
              key={lesson.topic}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '12px',
                padding: '12px 16px',
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                backgroundColor: hidden ? '#fafafa' : 'white',
                opacity: hidden ? 0.7 : 1,
              }}
            >
              <div>
                <div style={{ fontWeight: '600', color: '#1f2937' }}>
                  {lesson.id}. {lesson.title}
                </div>
                <div style={{ fontSize: '12px', color: '#9ca3af' }}>{lesson.topic}</div>
              </div>
              <button
                onClick={() => toggle(lesson.topic, hidden)}
                disabled={saving}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '8px 14px',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: saving ? 'not-allowed' : 'pointer',
                  fontWeight: '600',
                  fontSize: '13px',
                  color: 'white',
                  backgroundColor: hidden ? '#16a34a' : '#6b7280',
                  opacity: saving ? 0.6 : 1,
                  whiteSpace: 'nowrap',
                }}
              >
                {hidden ? <Eye size={16} /> : <EyeOff size={16} />}
                {saving ? 'Ukládám…' : hidden ? 'Zobrazit' : 'Schovat'}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LessonVisibilityManager;
